module.exports = __webpack_public_path__ + "static/media/Lås.9eff24c3.PNG";